import { FormGroup } from "react-bootstrap";
import { CSSProperties } from "styled-components";

import AutocompleteStyles from "../styles/components/AutocompleteStyles";

type Option = string | Record<string, any>;

interface AutocompleteProps {
    label?: string;
    onChange?: ((selected: Option[]) => void) | undefined;
    options: Option[];
    placeholder?: string;
    selected?: Option[] | undefined;
    extraOptions?: boolean;
    disabled?: boolean;
    style?: CSSProperties;
    className?: string;
}

function AutocompleteAbono({
    label,
    onChange,
    options,
    placeholder,
    selected,
    extraOptions,
    style,
    disabled,
    className,
}: AutocompleteProps) {
    const { StyledFormSelect, StyledLabel } = AutocompleteStyles;

    const styleGroup: CSSProperties = {
        width: "100%",
        maxWidth: "735px",
        marginBottom: "24px",
    };

    const filterByFields = ["value", "label"];

    return (
        <FormGroup style={style || styleGroup}>
            {label ? <StyledLabel>{label}</StyledLabel> : null}
            <StyledFormSelect
                id="basic-example"
                onChange={onChange}
                options={options}
                placeholder={placeholder}
                selected={selected}
                clearButton
                className={className}
                disabled={disabled}
                paginationText="Mais resultados"
                emptyLabel="Nenhum resultado encontrado"
                filterBy={filterByFields}
                renderMenuItemChildren={(option: any) => (
                    <div>
                        {option?.label}
                        {extraOptions ? (
                            <div>
                                <small>matricula: {option.value}</small>
                            </div>
                        ) : null}
                    </div>
                )}
            />
        </FormGroup>
    );
}

export default AutocompleteAbono;
